const zoomChange = 5.64;

const getStatesLayer = (stateColors, isCountyLevel) => {
  return {
    id: 'states',
    type: 'fill',
    'source-layer': 'cb_2018_us_state_500k-6expns',
    paint: {
      'fill-outline-color': 'rgba(0,0,0,0.2)',
      'fill-color': stateColors
    },
    filter: ['in', ['get', 'STATEFP'], ['literal', ['10', '11', '17', '18', '24', '26', '27', '34', '36', '37', '39', '42', '45', '51', '54', '55']]],
    maxzoom: isCountyLevel ? 3 : zoomChange
  };
};

const getCountiesLayer = (countyColors, isCountyLevel) => {
  return {
    id: 'counties',
    type: 'fill',
    'source-layer': 'cb_2018_us_county_500k-bbf38a',
    paint: {
      'fill-outline-color': 'rgba(0,0,0,0.2)',
      'fill-color': countyColors
    },
    filter: ['in', ['get', 'STATEFP'], ['literal', ['10', '11', '17', '18', '24', '26', '27', '34', '36', '37', '39', '42', '45', '51', '54', '55']]],
    minzoom: isCountyLevel ? 3 : zoomChange
  };
};

const getCountyLines = (isCountyLevel) => {
  return {
    id: 'counties-lines',
    type: 'line',
    'source-layer': 'cb_2018_us_county_500k-bbf38a',
    paint: {
      'line-color': 'rgba(179,179,179,1)',
      'line-width': 1
    },
    filter: ['in', ['get', 'STATEFP'], ['literal', ['10', '11', '17', '18', '24', '26', '27', '34', '36', '37', '39', '42', '45', '51', '54', '55']]],
    minzoom: isCountyLevel ? 3 : zoomChange
  };
};

const highlightStateLayer = {
  id: 'state-highlighted',
  type: 'line',
  'source-layer': 'cb_2018_us_state_500k-6expns',
  paint: {
    'line-width': 3,
    'line-color': 'rgba(0, 0, 0, 0.5)',
  },
  layout: {
    'line-join': 'round'
  }
};

const highlightCountyLayer = {
  id: 'county-highlighted',
  type: 'line',
  'source-layer': 'cb_2018_us_county_500k-bbf38a',
  paint: {
    'line-width': 3,
    'line-color': 'rgba(0, 0, 0, 0.5)'
  },
  layout: {
    'line-join': 'round'
  }
};


export { getStatesLayer, getCountiesLayer, getCountyLines, highlightStateLayer, highlightCountyLayer, zoomChange };